function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($helpers, JSON, Object, document, isMaximized) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['support-widget-form'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("support-widget-form", {
          "attrs": __vjadeStringifyAttrsIfObj($helpers.getFormAttributes()),
          "on": {
            'close': $helpers.handleSupportWidgetClosed,
            'dock': $helpers.handleSupportWidgetUnmaximized,
            'maximize': $helpers.handleSupportWidgetMaximized,
            'state-change': $helpers.handleFormStateChange,
          },
        }));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    return {
      value: (h("div", {
        "class": {
          'support-widget-container': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("mp-modal", {
          "attrs": __vjadeStringifyAttrsIfObj({
            closeable: false,
            'grow-to-content': true,
            'hide-close-button': true,
            open: isMaximized,
            'style-override': `.mp-modal-main { background: none !important; box-shadow: none !important; }`,
          }),
          "hook": {
            insert: vnode => document.body.appendChild(vnode.elm),
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((isMaximized) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(jade_mixins['support-widget-form'].call(this));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat((!isMaximized) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(jade_mixins['support-widget-form'].call(this));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "document" in locals ? locals.document : typeof document !== "undefined" ? document : undefined, "isMaximized" in locals ? locals.isMaximized : typeof isMaximized !== "undefined" ? isMaximized : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;